import { render, staticRenderFns } from "./VrRefundForm.vue?vue&type=template&id=6093e0a9&scoped=true&"
import script from "./VrRefundForm.vue?vue&type=script&lang=js&"
export * from "./VrRefundForm.vue?vue&type=script&lang=js&"
import style0 from "./VrRefundForm.vue?vue&type=style&index=0&id=6093e0a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6093e0a9",
  null
  
)

export default component.exports